<template>
    <span :title="JSON.stringify(workflow)">#{{workflow.id}} {{workflow.name}}</span>
</template>

<script>
export default {
    name : "WorkflowById",

    props : ['value'],

    data() {
        return {
            workflow : []
        };
    },

    mounted() {
        var _this = this;
        sdk.TicketWorkflowApi().findById({
            id : _this.value
        }).then(res => {
            _this.workflow = res || { id : _this.value };
        });
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/setting/WorkflowById.vue